/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { type DurationLike } from 'luxon'

import { type INavLink } from 'platform-core'
import pkg from '../../package.json'
import { Dashboard, SettingsHome } from '@/routes'

export const VERSION = pkg.version

export const APP_DOMAIN = process.env.REACT_APP_APP_DOMAIN!

export const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT!

export const UI_ENDPOINT = process.env.REACT_APP_UI_ENDPOINT!

export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY!

export const SUPPORT_EMAIL = 'support@proptrakx.com'

export const SUPPORT_NUMBER = '(225) 555 - 1234'

export const COOKIE_NAME = 'ptx-session'

export const COOKIE_LENGTH: DurationLike = { years: 2 }

export const COOKIE_SAME_SITE_MODE: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None' | undefined = 'strict'

export const ROUTES: INavLink[] = [
  {
    name: 'Dashboard',
    link: '/',
    icon: 'dashboard',
    component: Dashboard
  },
  {
    name: 'My Airframes',
    icon: 'connecting_airports',
    metadata: {
      children: []
    }
  },

  { /* Separator */ },

  {
    name: 'Settings',
    link: '/settings',
    icon: 'settings',
    component: SettingsHome
  }
]

export const AUTHENTICATION_ERRORS: string[] = [
  'Authentication is required for this endpoint',
  'The authorization token provided is invalid'
]

// Non-sidebar links (other routes like Airframes)
export const EXTRA_ROUTES: INavLink[] = [
  { name: 'Airframes', link: '/airframes', icon: 'connecting_airports' }
]

export const ROUTE_PATHS: Array<string | null> = [
  ...ROUTES.map(route => route.link ? route.link.substring(1) : null),
  ...EXTRA_ROUTES.map(route => route.link ? route.link.substring(1) : null)
].filter(v => !!v)
